import {userUrls, user} from './user'
import {jobUrls, job} from './job'
import {shopUrls, shop} from './shop'

export const accountUrls = [
  ...userUrls,
  ...jobUrls,
  ...shopUrls
]

export const account = {
  user,
  job,
  shop
}



// WEBPACK FOOTER //
// ./src/api/gip/account/index.js